import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { postManDelta, postManAction, postManGraph, postManTotal, PostManDetails } from "../../actions/leakedCredentials";
import Pagination from "../Pagination/Pagination";
import BasicLineColumn from "../common/apexChart/lineChart";
import "../../assets/css/recommendation-modal.css";
import * as FileSaver from "file-saver";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { API_URL } from "../../utils/constant";
import axios from "axios";
import moment from "moment";
import $ from "jquery";
import { rescanSingle } from "../../actions/users";
import PieChart from "../../components/common/dashboard12/piechart.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import ImageModal from "../common/ImageModal";

const PostManMonitoring = () => {
  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });

  const auth = useSelector((state) => state?.auth?.user);
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.de?.e;
  });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  // Extract keywords from client data
  const clientKeywords = client?.keyWord || [];
  const keywordOptions = ['all', ...clientKeywords];

  const dispatch = useDispatch();
  const [toggleArray, setToggleArray] = useState({});
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState([]);
  const [search, setSearch] = useState("");
  const [filterData, setfilterData] = useState("all");
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [isModalTrue, setModalSet] = useState(false);
  const [detail, setdetail] = useState([]);
  const [category, setCategory] = useState("all");
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [screenshotError, setScreenshotError] = useState(false);
  const [screenshotUrl, setScreenshotUrl] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageModalSrc, setImageModalSrc] = useState("");
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [totalItem, setTotalItem] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('all');
  const state = useSelector((state) => state?.leakedCredential?.postman?.data);
  const totalItemCount = useSelector((state) => state?.leakedCredential?.postman?.totalCount);
  const oldDnsDetails = useSelector(
    (state) => state.leakedCredential?.postmanGraph?.data
  );
  const detailsState = useSelector(
    (state) => state?.leakedCredential?.postmandetails?.data
  );

  let ipArray = [];

  if (state) {
    ipArray.push(state?.length);
  }

  useEffect(() => {
    postManDelta(id, dispatch, page, category, startDate, endDate, limit, search, keyword);
  }, [id, dispatch, page, category, startDate, endDate, limit, search, keyword]);

  useEffect(() => {
    postManGraph(id, dispatch)
  }, [id, dispatch])

  useEffect(() => {
    setTotalItem(totalItemCount)
  }, [totalItemCount])

  let mapData = state;
  let currentTableData = mapData;

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event) => {
    if (event === "markAsRemidiated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated?",
        type: "green",
        buttons: {
          ok: {
            text: "Yes, Mark as Remediated",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              let ids = [];
              ids.push(_id);
              const data = {
                action: "markAsRemediated",
                postmanRecordIds: selectedIds.length === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              postManAction(id, dispatch, page, data, category, limit, search, keyword);
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setSelectedIds([]);
            },
          },
          cancel: function () {
          },
        },
      });
    }

  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      postmanRecordIds: selectedIds == 0 ? ids : selectedIds,
    };
    postManAction(id, dispatch, page, data, category, limit, search, keyword);
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      postmanRecordIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    postManAction(id, dispatch, page, data, category, limit, search, keyword);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  // Function to view details in modal
  const viewDetails = (postmanId) => {
    PostManDetails(postmanId, id, dispatch);
    setModalSet(true);
  };

  const viewDetailsSlider = (row) => {
    setSelectedRowDetails(row);
    setDetailsModal(true);
  };

  // Manage body scroll when details modal is open
  useEffect(() => {
    if (detailsModal) {
      document.body.classList.add('details-slider-open');
    } else {
      document.body.classList.remove('details-slider-open');
    }
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('details-slider-open');
    };
  }, [detailsModal]);

  // Reset screenshot state when selectedRowDetails changes
  useEffect(() => {
    if (selectedRowDetails?.screenshot) {
      setScreenshotError(false);
      setScreenshotUrl(selectedRowDetails.screenshot);
    } else {
      setScreenshotError(false);
      setScreenshotUrl(null);
    }
  }, [selectedRowDetails]);

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(`${API_URL}/postmanRecord/${id}/excel`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}Postman Monitoring.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const reScan = () => {
    let data = {
      "moduleName": ["postman"]
    }
    rescanSingle(id, data)
  }

  // Add these new state variables for date picker
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);
  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  // Update startDateObj and endDateObj whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Update tempStartDate and tempEndDate whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add this function to format the displayed date range
  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  // Add this function to handle applying the selected date range
  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
  };

  // Add this function to clear all dates
  const cancelDateSelection = () => {
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };

  // Render scalar or structured values safely
  const renderValueDisplay = (val) => {
    if (val === null || val === undefined) return "N/A";
    if (typeof val === "string" || typeof val === "number" || typeof val === "boolean") return val;
    try {
      return (
        <pre style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          {JSON.stringify(val, null, 2)}
        </pre>
      );
    } catch (e) {
      return String(val);
    }
  };

  const renderInterestingList = (items, label) => (
    <div style={{ marginBottom: "8px" }}>
      <strong>Interesting Values ({label}):</strong>
      <ul style={{ margin: "8px 0 0", paddingLeft: "16px" }}>
        {items.map((item, idx) => (
          <li key={`${label}-${idx}`} style={{ marginBottom: "8px" }}>
            {item?.path && (
              <div style={{ wordBreak: "break-all" }}>
                <strong>Path:</strong> <code style={{ background: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{item.path}</code>
              </div>
            )}
            {item?.pattern_type && (
              <div>
                <strong>Pattern:</strong> <span className="badge badge-info" style={{ marginLeft: "4px" }}>{item.pattern_type}</span>
              </div>
            )}
            {item?.content && (
              <div style={{ wordBreak: "break-word" }}>
                <strong>Content:</strong> <span>{renderValueDisplay(item.content)}</span>
              </div>
            )}
            {item?.key !== undefined && (
              <div><strong>Key:</strong> {renderValueDisplay(item.key)}</div>
            )}
            {item?.value !== undefined && (
              <div style={{ wordBreak: "break-word" }}>
                <strong>Value:</strong> {renderValueDisplay(item.value)}
              </div>
            )}
            {item?.data_type && (
              <div><strong>Data Type:</strong> {item.data_type}</div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="container-fluid">
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Postman monitoring</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                    <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                  </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      <Link to={`/dashboard/vendor/${vendorId}`}
                      >{vendorName}</Link>
                    </li> : ''
                }
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "white" }}
                >
                  Postman Monitoring
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
            <span>
              {auth?.accessLevel == "Admin" && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    reScan();
                  }}
                  style={{ color: "black", fontWeight: "bold" }}
                  className="btn btn-primary mr-1"
                >
                  Rescan
                </a>
              )}
            </span>
            <span className="mr-2">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setIsRecommendationModal(true);
                }}
                href="#"
                className="btn btn-sm btn-primary mr-1"
                style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
              >
                <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                Recommendation
              </a>
            </span>
            <span>
              {client?.subscriptionType != "trial" && mapData?.length !== 0 && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-sm btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              )}
            </span>
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 col-md-12">
          <div className="card RecordFoundCard">
            <div className="body" style={{ minHeight: "440px" }}>
              <h6 className="mb-3 welcome-textSmall">Records Found</h6>
              <div className="d-flex mb-4 justify-content-center">
                {totalItemCount && <PieChart series={[totalItemCount]} label={["recordFound"]} />}
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-8 col-md-12 col-sm-12">
          <div className="card">
            <div className="body" style={{ minHeight: "440px" }}>
              <h6 className="welcome-textSmall">Previous scan details</h6>
              {oldDnsDetails && (
                <BasicLineColumn
                  dates={oldDnsDetails?.dates || []}
                  ipArray={oldDnsDetails?.scanDetails || []}
                  color={["#08283f"]}
                  yAxis="Records Found"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
        <li className="nav-item">
          <a
            className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("all");
              setPage(1);
              setSelectedIds([]);
              setSearch("");
              setKeyword("all");
            }}
          >
            Current
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("risk-accepted");
              setPage(1);
              setSearch("");
              setSelectedIds([]);
              setKeyword("all");
            }}
          >
            Risk Accepted
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("false-positive");
              setPage(1);
              setSearch("");
              setSelectedIds([]);
              setKeyword("all");
            }}
          >
            False Positive
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("remidiated");
              setPage(1);
              setSearch("");
              setSelectedIds([]);
              setKeyword("all");
            }}
          >
            Remediated
          </a>
        </li>
      </ul>
      <div className="card card_tableBox">
        <div className="body">
          <div className="row">
            <div className="col-sm-3 mb-2">
                <input
                  class="form-control form-control-sm ml-0 my-1"
                  type="text"
                  placeholder="Search"
                  aria-label="Search"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                />
            </div>
            <div className="col-sm-3 mb-2">
              <div className="date-picker-container">
                <div className="date-range-input">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Select date range"
                    value={formatDateRange()}
                    onClick={() => setDatePickerOpen(true)}
                    readOnly
                  />
                  <span className="calendar-icon">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-sm-2 mb-2">
              <select
                className="form-control form-control-sm"
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                  setPage(1);
                }}
              >
                <option value="all">All Keywords</option>
                {clientKeywords.map((kw, index) => (
                  <option key={index} value={kw}>
                    {kw}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-sm-4 mb-2">
              {selectedIds.length > 1 && category === "all" && userPermission && (
                <Box sx={{ width: 160 }}>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedValue}
                      onChange={(event) => {
                        setAction(event.target.value);
                        snooze("", event.target.value);
                      }}
                    >
                      <MenuItem value="pleaseSelect">Snooze Options</MenuItem>
                      <MenuItem
                        value="riskAccepted"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        Risk Accepted
                      </MenuItem>
                      <MenuItem
                        value="markAsFalsePositive"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        False Positive
                      </MenuItem>
                      <MenuItem value="markAsRemidiated">Remediated</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              )}
              {selectedIds.length > 1 && userPermission &&
                (category == "false-positive" ||
                  category == "risk-accepted") && (
                  <button
                    className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                    onClick={() => Unsnoozed("")}
                  >
                    Unsnooze
                  </button>
                )}
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-custom spacing5 mb-0" style={{ tableLayout: "auto", width: "100%" }}>
              <thead>
                <tr>
                  {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                    category === "risk-accepted" ||
                    category === "false-positive") && (
                      <th>
                        <input
                          type="checkbox"
                          checked={
                            selectedIds == 0 ? false : multiCheckTrue
                          }
                          onClick={() => {
                            multicheck(currentTableData);
                          }}
                          className="checkUncheck"
                        />
                      </th>
                    )}
                  <th style={{ 
                    whiteSpace: "normal", 
                    wordBreak: "break-word",
                    maxWidth: "250px",
                    minWidth: "200px"
                  }}>Workspace Url</th>
                  <th style={{ 
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    maxWidth: "200px",
                    minWidth: "150px"
                  }}>User Detail</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                  <th>View Details</th>
                  {category !== "all" && <th>Action Note</th>}
                  {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                    category === "risk-accepted" ||
                    category === "false-positive") && (
                      <th style={{ width: "80" }}>Action</th>
                    )}
                </tr>
              </thead>
              <tbody>
                {currentTableData?.map((row, index) => {
                  return (
                    <tr>
                      {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                        category === "risk-accepted" ||
                        category === "false-positive") && (
                          <td>
                            <input
                              onClick={() => singleClick(row?._id)}
                              checked={selectedIds?.includes(row?._id)}
                              type="checkbox"
                              className="checkUncheck"
                            />
                          </td>
                        )}
                      <td style={{ 
                        whiteSpace: "normal",
                        wordBreak: "break-all",
                        overflowWrap: "break-word",
                        maxWidth: "250px",
                        minWidth: "200px",
                        verticalAlign: "top",
                        padding: "8px",
                        lineHeight: "1.5"
                      }}>
                        {row?.request_url ? (
                          <a 
                            href={row.request_url} 
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ 
                              color: "#17a2b8",
                              textDecoration: "none",
                              wordBreak: "break-all",
                              overflowWrap: "break-word",
                              display: "inline-block",
                              maxWidth: "100%"
                            }}
                          >
                            {row.request_url}
                          </a>
                        ) : "N/A"}
                      </td>
                      <td style={{ 
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        maxWidth: "200px",
                        minWidth: "150px",
                        verticalAlign: "top",
                        padding: "8px",
                        lineHeight: "1.5"
                      }}>
                        <div style={{ 
                          wordBreak: "break-word",
                          overflowWrap: "break-word"
                        }}>
                          {row?.user_details ? row.user_details : "N/A"}
                        </div>
                      </td>
                      <td>{row?.createdAt ? moment(row?.createdAt).format(
                        "DD-MM-YYYY"
                      ) : "NA"}</td>
                      <td>{row?.last_updated_at ? moment(row?.last_updated_at).format(
                        "DD-MM-YYYY"
                      ) : "NA"}</td>
                      <td>
                        <button
                          className="btn btn-sm"
                          onClick={() => viewDetailsSlider(row)}
                          style={{
                            backgroundColor: "#17a2b8",
                            borderColor: "#17a2b8",
                            color: "#fff",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            transition: "all 0.3s ease",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px"
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#138496";
                            e.target.style.borderColor = "#117a8b";
                            e.target.style.transform = "translateY(-1px)";
                            e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#17a2b8";
                            e.target.style.borderColor = "#17a2b8";
                            e.target.style.transform = "translateY(0)";
                            e.target.style.boxShadow = "none";
                          }}
                        >
                          <i className="fa fa-info-circle" style={{ fontSize: "14px" }}></i>
                          <span className="details-slider-action-btn-text">View Details</span>
                        </button>
                      </td>
                      {category !== "all" && <td style={{ whiteSpace: "unset" }}>{row?.actionNote ? row.actionNote : "N/A"}</td>}
                      {row?.remediationPending == true ? <td>Retest in progress</td> : <>
                        {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                          <td>
                            <Box sx={{ width: 160 }}>
                              <FormControl fullWidth>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={selectedValue}
                                  onChange={(event) => {
                                    setAction(event.target.value);
                                    snooze(row?._id, event.target.value);
                                  }}
                                >
                                  <MenuItem value="pleaseSelect">
                                    Snooze Options
                                  </MenuItem>
                                  <MenuItem
                                    value="riskAccepted"
                                    onClick={() => {
                                      addModal();
                                      setLookalikeAppId([row._id]);
                                    }}
                                  >
                                    Risk Accepted
                                  </MenuItem>
                                  <MenuItem
                                    value="markAsFalsePositive"
                                    onClick={() => {
                                      addModal();
                                      setLookalikeAppId([row._id]);
                                    }}
                                  >
                                    False Positive
                                  </MenuItem>
                                  <MenuItem value="markAsRemidiated">
                                    Remediated
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Box>
                          </td>
                        )}
                      </>
                      }
                      {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                        category === "false-positive") && (
                          <td>
                            <button
                              className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                              onClick={() => Unsnoozed(row?._id)}
                            >
                              Unsnooze
                            </button>
                          </td>
                        )}
                      <td></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between align-content-center">
            <div className="dataTables_paginate">
              {totalItem > 0 && (
                <Pagination
                  className="pagination-bar"
                  currentPage={page}
                  totalCount={totalItem}
                  pageSize={limit}
                  onPageChange={(page) => setPage(page)}
                />
              )}
            </div>
            {totalItem > 10 && (
              <select
                value={limit}
                onChange={(e) => {
                  setLimit(e.target.value)
                }}
                className="form-control limitSelectBox"
              >
                <option value={10}>10 per page</option>
                <option value={25}>25 per page</option>
                <option value={50}>50 per page</option>
                <option value={100}>100 per page</option>
              </select>
            )}
          </div>
        </div>
      </div>

      {/* Postman Monitoring Details Slider */}
      <div
        className={`details-slider-overlay ${detailsModal ? "show" : ""}`}
        onClick={() => {
          setDetailsModal(false);
          setSelectedRowDetails(null);
        }}
      ></div>
      <div className={`details-slider-panel ${detailsModal ? "open" : ""}`}>
        <div className="details-slider-content">
          <div className="details-slider-header">
            <h5 style={{ color: "white", margin: 0 }}>
              <i className="fa fa-code mr-2"></i>
              Postman Monitoring Details
              {selectedRowDetails?.request_url && (
                <span className="ml-2" style={{ fontSize: "0.85em", opacity: 0.9, color: "white" }}>
                  - {selectedRowDetails.request_url.split('/').pop() || selectedRowDetails.request_url}
                </span>
              )}
            </h5>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <button
                type="button"
                className="details-slider-close"
                onClick={() => {
                  setDetailsModal(false);
                  setSelectedRowDetails(null);
                }}
                aria-label="Close"
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div className="details-slider-body">
            {selectedRowDetails && (
              <>
                {/* Risk Description Section */}
                {selectedRowDetails?.risk_description && (
                  <div className="details-section" style={{ borderColor: "#ffc107", backgroundColor: "#fff3cd" }}>
                    <div className="details-section-title" style={{ color: "#856404" }}>
                      <i className="fa fa-exclamation-triangle" style={{ color: "#856404" }}></i>
                      Risk Description
                    </div>
                    <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                      <p style={{ color: "#856404", margin: 0, lineHeight: "1.6" }}>
                        {selectedRowDetails.risk_description}
                      </p>
                    </div>
                  </div>
                )}

                {/* Impact Section */}
                {selectedRowDetails?.impact && (
                  <div className="details-section" style={{ borderColor: "#dc3545", backgroundColor: "#f8d7da" }}>
                    <div className="details-section-title" style={{ color: "#721c24" }}>
                      <i className="fa fa-exclamation-circle" style={{ color: "#721c24" }}></i>
                      Impact
                    </div>
                    <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                      <p style={{ color: "#721c24", margin: 0, lineHeight: "1.6" }}>
                        {selectedRowDetails.impact}
                      </p>
                    </div>
                  </div>
                )}

                {/* Basic Information Section */}
                <div className="details-section">
                  <div className="details-section-title">
                    <i className="fa fa-info-circle"></i>
                    Basic Information
                  </div>
                  <div className="details-info-item">
                    <span className="details-info-label">Request URL:</span>
                    <span className="details-info-value">
                      {selectedRowDetails?.request_url ? (
                        <a href={selectedRowDetails.request_url} target="_blank" rel="noopener noreferrer" style={{ color: "#17a2b8", wordBreak: "break-all" }}>
                          {selectedRowDetails.request_url}
                        </a>
                      ) : "N/A"}
                    </span>
                  </div>
                  {selectedRowDetails?.url && (
                    <div className="details-info-item">
                      <span className="details-info-label">URL:</span>
                      <span className="details-info-value">
                        <a href={selectedRowDetails.url} target="_blank" rel="noopener noreferrer" style={{ color: "#17a2b8", wordBreak: "break-all" }}>
                          {selectedRowDetails.url}
                        </a>
                      </span>
                    </div>
                  )}
                  <div className="details-info-item">
                    <span className="details-info-label">User Details:</span>
                    <span className="details-info-value">
                      {selectedRowDetails?.user_details || "N/A"}
                    </span>
                  </div>
                  {selectedRowDetails?.scan_input && (
                    <div className="details-info-item">
                      <span className="details-info-label">Scan Input:</span>
                      <span className="details-info-value">
                        <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px", wordBreak: "break-all" }}>
                          {selectedRowDetails.scan_input}
                        </code>
                      </span>
                    </div>
                  )}
                  {selectedRowDetails?.scan_input_type && (
                    <div className="details-info-item">
                      <span className="details-info-label">Scan Input Type:</span>
                      <span className="details-info-value">
                        {selectedRowDetails.scan_input_type}
                      </span>
                    </div>
                  )}
                  
                  
                  {selectedRowDetails?.actionNote && (
                    <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                      <span className="details-info-label" style={{ marginBottom: "8px" }}>Action Note:</span>
                      <span className="details-info-value" style={{ padding: "8px", backgroundColor: "#f8f9fa", borderRadius: "4px", width: "100%" }}>
                        {selectedRowDetails.actionNote}
                      </span>
                    </div>
                  )}
                </div>

                {/* Screenshot Section */}
                {selectedRowDetails?.screenshot && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-image"></i>
                      Screenshot
                    </div>
                    <div style={{ 
                      display: "flex", 
                      justifyContent: "center", 
                      alignItems: "center",
                      padding: "15px",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "4px",
                      minHeight: "200px"
                    }}>
                      {screenshotError ? (
                        <div style={{ textAlign: "center", padding: "20px", color: "#6c757d" }}>
                          <i className="fa fa-exclamation-triangle" style={{ fontSize: "24px", marginBottom: "10px", display: "block", color: "#ffc107" }}></i>
                          <p style={{ marginBottom: "10px" }}>Unable to load screenshot</p>
                          <a 
                            href={selectedRowDetails.screenshot} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            style={{ color: "#453acd", textDecoration: "underline" }}
                          >
                            <i className="fa fa-external-link mr-1"></i>
                            Open screenshot URL
                          </a>
                        </div>
                      ) : (
                        <img
                          src={screenshotUrl || selectedRowDetails.screenshot}
                          alt="Screenshot"
                          className="image-clickable"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "500px",
                            borderRadius: "4px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            objectFit: "contain"
                          }}
                          onClick={() => {
                            setImageModalSrc(screenshotUrl || selectedRowDetails.screenshot);
                            setImageModalOpen(true);
                          }}
                          onError={() => {
                            // Set error state to show fallback UI
                            setScreenshotError(true);
                          }}
                          onLoad={() => {
                            setScreenshotError(false);
                          }}
                          title="Click to open in new tab"
                        />
                      )}
                    </div>
                    <div style={{ marginTop: "10px", textAlign: "center" }}>
                      <a 
                        href={selectedRowDetails.screenshot} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ 
                          color: "#453acd", 
                          textDecoration: "none",
                          fontSize: "0.85rem"
                        }}
                      >
                        <i className="fa fa-external-link mr-1"></i>
                        Open screenshot in new tab
                      </a>
                    </div>
                  </div>
                )}

                {/* Value Array Section - Only show if data exists */}
                {selectedRowDetails?.value && selectedRowDetails.value.length > 0 && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-list"></i>
                      Value Details
                    </div>
                    {selectedRowDetails.value.map((val, valIndex) => {
                      const hasPaths = val?.paths && val.paths.length > 0;
                      const hasAuth = val?.interesting_values_found_in_authentication && val.interesting_values_found_in_authentication.length > 0;
                      const hasHeaders = val?.interesting_values_found_in_headers && val.interesting_values_found_in_headers.length > 0;
                      const hasBody = val?.interesting_values_found_in_body && val.interesting_values_found_in_body.length > 0;
                      const hasAny = hasPaths || hasAuth || hasHeaders || hasBody;

                      return (
                        <div key={valIndex} className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start", padding: "12px 0", borderBottom: "1px solid #f1f3f5" }}>
                          <div style={{ width: "100%" }}>
                            {hasPaths && val.paths.map((pathItem, index) => (
                              <div key={index} style={{ marginBottom: "12px" }}>
                                {pathItem?.path && (
                                  <div style={{ marginBottom: "8px" }}>
                                    <strong>Path:</strong> <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{pathItem.path}</code>
                                  </div>
                                )}
                                {pathItem?.pattern_name && (
                                  <div style={{ marginBottom: "8px" }}>
                                    <strong>Pattern Type:</strong>
                                    <span className={`ml-2 badge ${
                                      pathItem.pattern_name === "authorization_basic" ? "badge-warning" :
                                      pathItem.pattern_name === "username" ? "badge-info" :
                                      pathItem.username_password ? "badge-danger" : "badge-secondary"
                                    }`}>
                                      {pathItem.pattern_name}
                                    </span>
                                  </div>
                                )}
                                {pathItem?.username_password && (
                                  <div style={{ marginBottom: "8px" }}>
                                    <div><strong>Username:</strong> {pathItem.username_password.username}</div>
                                    <div><strong>Password:</strong> {pathItem.username_password.password}</div>
                                  </div>
                                )}
                                {pathItem?.content && !pathItem?.username_password && (
                                  <div style={{ marginBottom: "8px" }}>
                                    <strong>Content:</strong> <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{pathItem.content}</code>
                                  </div>
                                )}
                              </div>
                            ))}

                            {hasAuth && (
                              renderInterestingList(val.interesting_values_found_in_authentication, "Auth")
                            )}

                            {hasHeaders && (
                              renderInterestingList(val.interesting_values_found_in_headers, "Headers")
                            )}

                            {hasBody && (
                              renderInterestingList(val.interesting_values_found_in_body, "Body")
                            )}

                            {!hasAny && (
                              <span className="details-info-value text-muted">No value details available.</span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <div
        className={`modal fade Form-Wizard-modal ${isModalTrue == true ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-xl" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Postman Monitoring Details
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setModalSet(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page">
              <div className="col-xl-12 col-lg-12 col-md-12">
                {detailsState ? (
                  <div>
                    {/* Basic Information */}
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <h6><strong>Request URL:</strong></h6>
                        <p>
                          <a href={detailsState?.request_url} target="_blank" rel="noopener noreferrer">
                            {detailsState?.request_url || "N/A"}
                          </a>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <h6><strong>User Details:</strong></h6>
                        <p>{detailsState?.user_details || "N/A"}</p>
                      </div>
                    </div>
                    
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <h6><strong>Last Updated:</strong></h6>
                        <p>{detailsState?.last_updated_at ? moment(detailsState.last_updated_at).format("DD-MM-YYYY HH:mm") : "N/A"}</p>
                      </div>
                      <div className="col-md-6">
                        <h6><strong>Swagger Hub:</strong></h6>
                        <p>{detailsState?.swaggerHub ? "Yes" : "No"}</p>
                      </div>
                    </div>

                    <hr />

                    {/* Paths and Credentials Details */}
                    <h5 className="mb-3">Found Credentials and Patterns</h5>
                    <div className="table-responsive">
                      <table className="table table-custom spacing5 mb-0">
                        <thead>
                          <tr>
                            <th>Path</th>
                            <th>Pattern Type</th>
                            <th>Content/Credentials</th>
                          </tr>
                        </thead>
                        <tbody>
                          {detailsState?.value && detailsState.value.length > 0 && 
                            detailsState.value[0]?.paths?.map((pathItem, index) => (
                              <tr key={index}>
                                <td>
                                  <code>{pathItem?.path || "N/A"}</code>
                                </td>
                                <td>
                                  <span className={`badge ${
                                    pathItem?.pattern_name === 'authorization_basic' ? 'badge-warning' :
                                    pathItem?.pattern_name === 'username' ? 'badge-info' :
                                    pathItem?.username_password ? 'badge-danger' : 'badge-secondary'
                                  }`}>
                                    {pathItem?.pattern_name || (pathItem?.username_password ? 'username_password' : 'Unknown')}
                                  </span>
                                </td>
                                <td>
                                  {pathItem?.username_password ? (
                                    <div>
                                      <strong>Username:</strong> {pathItem.username_password.username}<br />
                                      <strong>Password:</strong> {pathItem.username_password.password}
                                    </div>
                                  ) : (
                                    <span>{pathItem?.content || "N/A"}</span>
                                  )}
                                </td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>

                    {/* Status Information */}
                    <hr />
                  </div>
                ) : (
                  <div className="text-center p-4">
                    <p>Loading details...</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {action == "markAsFalsePositive"
                  ? "Mark As False Positive"
                  : "Risk Accepted"}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModal("");
                  setActionNote("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page modal_mob">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <label className="col-lg-6 col-md-12">Snooze for</label>
                      <div className="form-group ol-lg-12 col-md-12">
                        <select
                          className="custom-select custom-select-sm form-control form-control-sm"
                          onChange={(e) => setForValue(e.target.value)}
                        >
                          <option value="forever">Forever</option>
                          <option value="3 months">3 Months</option>
                          <option value="6 months">6 Months</option>
                          <option value="12 months">12 Months</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label className="col-lg-12 col-md-12">Detail</label>
                      <div className="form-group col-lg-12 col-md-12">
                        <textarea
                          onChange={(e) => setActionNote(e.target.value)}
                          value={actionNote}
                          className="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12"
                      style={{ marginRight: "28px" }}
                    >
                      <button
                        type="button"
                        style={{ color: "black", fontWeight: "bold" }}
                        onClick={submit}
                        className="btn btn-round btn-primary mr-1 pull-right"
                      >
                        Submit
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={() => {
                          setModal("");
                          setActionNote("");
                        }}
                        className="btn btn-round btn-default pull-right"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add the date picker overlay */}
      {datePickerOpen && (
        <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
          <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
            <div className="date-range-picker-header">
              {tempStartDate && tempEndDate
                ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                : "Select date range"}
            </div>
            <div className="date-range-calendars">
              <div>
                <h6>From</h6>
                <DatePicker
                  selected={tempStartDate}
                  onChange={(date) => {
                    setTempStartDate(date);
                    if (tempEndDate && date > tempEndDate) {
                      setTempEndDate(null);
                    }
                  }}
                  selectsStart
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
              <div>
                <h6>To</h6>
                <DatePicker
                  selected={tempEndDate}
                  onChange={(date) => setTempEndDate(date)}
                  selectsEnd
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  minDate={tempStartDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </div>
            <div className="date-range-actions">
              <button
                className="date-range-apply"
                onClick={applyDateRange}
              >
                Apply Filter
              </button>
              <button
                className="date-range-cancel"
                onClick={cancelDateSelection}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>
            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  Public Postman workspaces often expose API endpoints, example payloads, and authentication artifacts. When leaked, they provide attackers with ready-made reconnaissance of your APIs and environments.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Exposure Vectors</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Public Postman collections or environments containing API keys/tokens</li>
                      <li>Leaked bearer/Basic auth headers and session cookies in saved requests</li>
                      <li>Hardcoded credentials inside pre-request or test scripts</li>
                      <li>Internal hostnames, staging/prod URLs, and GraphQL schemas</li>
                      <li>Swagger/OpenAPI references linked from the collection</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Risk Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Credential theft leading to direct API abuse</li>
                      <li>Enumeration of internal endpoints and parameters</li>
                      <li>Replay of sample payloads to exfiltrate data</li>
                      <li>Privilege escalation via leaked environment variables</li>
                    </ul>
                  </div>
                </details>
              </div>

              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate Containment</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Make exposed collections/environments private or remove them</li>
                      <li>Rotate all tokens, keys, and credentials referenced</li>
                      <li>Invalidate shared links and remove public workspace visibility</li>
                      <li>Capture evidence (screenshots/links) for incident tracking</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.16.1.2 · Incident Response</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Credential & Token Hygiene</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Revoke leaked API tokens, OAuth secrets, and Basic auth creds</li>
                      <li>Review access logs for suspicious API calls</li>
                      <li>Disable long-lived tokens; enforce short TTL and scopes</li>
                    </ul>
                    <div className="compliance-tag">NIST SP 800-53 IA-5 · ISO 27001 A.9.4.3</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>API Hardening</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Enable rate limits, IP allowlists, and strict auth on exposed endpoints</li>
                      <li>Validate input schemas; block test payloads and mass assignment</li>
                      <li>Use separate keys for sandbox vs production; monitor anomaly patterns</li>
                    </ul>
                    <div className="compliance-tag">OWASP API Security · ISO 27001 A.14.2.5</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Process & Tooling</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Enforce secret scanning in Postman and CI/CD before publishing</li>
                      <li>Use environment variables and secret managers instead of hardcoding</li>
                      <li>Document incident timeline and update risk register</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.12.4.1 · A.14.2.8</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}

      <ImageModal
        isOpen={imageModalOpen}
        onClose={() => setImageModalOpen(false)}
        imageSrc={imageModalSrc}
      />
    </div>
  );
};
export default PostManMonitoring;
